import type { ReactNode } from "react";

import { Button } from "@jti/core-components/components/Button";

import styles from "./SelectedAddressViewCard.module.scss";

type SelectedAddressViewCardProps = {
  title?: string;
  children: ReactNode;
  onChange?: () => void;
  changeBtnText?: string;
};

export const SelectedAddressViewCard = ({ title, onChange, changeBtnText, children }: SelectedAddressViewCardProps) => {
  const actionButton = changeBtnText ? (
    <Button onClick={onChange} variant="text" data-testid="address-card-change-address-cta">
      {changeBtnText}
    </Button>
  ) : null;

  return (
    <div className={styles.wrapper}>
      {title && (
        <div className={styles.header}>
          <p className={styles.title}>{title}</p>
        </div>
      )}

      <div className={styles.content}>{children}</div>

      {actionButton && <div className={styles.changeAction}>{actionButton}</div>}
    </div>
  );
};
